import { instance2, TYPE_INSTANCE2 } from "App/constants"
import {
  defaultToastError,
  defaultToastSuccess,
  fetchData,
} from "App/utils/helpers"
import { useState } from "react"

const urlCreate = "registration/registration/addregistration_onsiterinapCOB"
const urlUpdate = "registration/registration/updateregistration_onsiterinapCOB"

export default function useCOB() {
  const [rowsCOB, setRowsCOB] = useState([])
  const [details, setDetails] = useState([])
  const [loadingCOB, setLoadingCOB] = useState(false)
  const [loadingUpdate, setLoadingUpdate] = useState(false)
  const [loadingCreate, setLoadingCreate] = useState(false)
  const [loadingDetails, setLoadingDetails] = useState(false)
  const [loadingPreviewFile, setLoadingPreviewFile] = useState(false)

  const setNewDataCOB = async (idKunjungan) => {
    try {
      setLoadingCOB(true)
      const res = await fetchData(
        TYPE_INSTANCE2,
        "/registration/registration/listregistration_onsiterinapCOB",
        "body",
        { params: { id_kunjungan: idKunjungan } },
      )
      return res
    } catch (error) {
      console.log("ERROR GET COB: ", error)
      return []
    } finally {
      setLoadingCOB(false)
    }
  }

  const createCOB = async (payload, callback) => {
    try {
      setLoadingCreate(true)
      const res = await instance2.post(urlCreate, payload)
      if (+res.status === 200) {
        callback && callback()
        return defaultToastSuccess(
          res.data?.message ?? "Sukses menambahkan COB",
        )
      } else {
        return defaultToastError(res.data?.message ?? "Gagal menambahkan COB")
      }
    } catch (error) {
      return defaultToastError(
        error?.response?.data?.message ?? "Terjadi Kesalahan",
      )
    } finally {
      setLoadingCreate(false)
    }
  }
  const updateCOB = async (payload, callback) => {
    try {
      setLoadingUpdate(true)
      const res = await instance2.put(urlUpdate, payload)
      if (+res.status === 200) {
        callback()
        return defaultToastSuccess(
          res.data?.message ?? "Sukses memperbarui COB",
        )
      } else {
        return defaultToastError(res.data?.message ?? "Gagal memperbarui COB")
      }
    } catch (error) {
      return defaultToastError(
        error?.response?.data?.message ?? "Terjadi Kesalahan",
      )
    } finally {
      setLoadingUpdate(false)
    }
  }

  const setNewDataDetails = async (idCOB) => {
    try {
      setLoadingDetails(true)
      const res = await fetchData(
        TYPE_INSTANCE2,
        "registration/registration/listregistration_onsiterinapdetailCOB",
        "body",
        { params: { id_cob: idCOB } },
      )
      setDetails(res)
    } catch (error) {
      return defaultToastError(
        error?.response?.data?.message ?? "Terjadi Kesalahan",
      )
    } finally {
      setLoadingDetails(false)
    }
  }

  const previewFiles = async (url_file, file_name, callback) => {
    try {
      setLoadingPreviewFile(true)
      const res = await instance2.post(
        "/download_file",
        {
          url: url_file + file_name,
        },
        {
          responseType: "blob",
        },
      )

      if (parseInt(res.status) === 200) {
        callback(res)
      } else {
        return defaultToastError(res.data?.message)
      }
    } catch (error) {
      return defaultToastError(error?.response?.data?.message ?? "Gagal")
    } finally {
      setLoadingPreviewFile(false)
    }
  }

  return {
    createCOB,
    updateCOB,
    setNewDataDetails,
    details,
    loadingUpdate,
    loadingDetails,
    previewFiles,
    loadingPreviewFile,
    loadingCreate,
    setNewDataCOB,
    loadingCOB,
    rowsCOB,
    setRowsCOB,
  }
}
